import { render, staticRenderFns } from "./vUnroundedValuesWarning.vue?vue&type=template&id=5b78f12c&scoped=true"
import script from "./vUnroundedValuesWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./vUnroundedValuesWarning.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vUnroundedValuesWarning.vue?vue&type=style&index=0&id=5b78f12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b78f12c",
  null
  
)

export default component.exports